export const getUrlPathname = (url: string): string => {
  const urlObject = new URL(url);
  return urlObject.pathname;
};

export const isAbsoluteUrl = (url: string): boolean => {
  const pat = /^https?:\/\//i;
  return pat.test(url);
};
